import script from "./CampaignEmail.vue?vue&type=script&setup=true&lang=ts"
export * from "./CampaignEmail.vue?vue&type=script&setup=true&lang=ts"

import "./CampaignEmail.vue?vue&type=style&index=0&id=14c4c2f8&scoped=true&lang=css"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14c4c2f8"]])

export default __exports__